// One value picked from a list that typing narrows.
//
// The input shows the picked option until someone types; what they type is a search, never a
// value. Leaving the field without picking drops the search and the value stays as it was -
// text that names no option is not kept. Emptying the input clears the value.

import { useId } from 'react';

import OptionList from './OptionList.jsx';
import { optionFor } from './optionSearch.js';
import useOptionList from './useOptionList.js';

export default function Combobox({ label, options, value, onChange, placeholder }) {
  const listId = useId();
  const list = useOptionList(options);
  const shown = list.typed ?? (value ? optionFor(options, value).label : '');

  const pick = (option) => {
    onChange(option.value);
    list.close();
  };

  return (
    <span className="combobox">
      <input
        role="combobox"
        aria-label={label}
        aria-expanded={list.open}
        aria-controls={listId}
        aria-autocomplete="list"
        value={shown}
        placeholder={placeholder}
        autoComplete="off"
        onChange={(event) => {
          list.type(event.target.value);
          if (event.target.value === '') onChange('');
        }}
        // The whole value is selected, so typing replaces it rather than adding to it.
        onFocus={(event) => event.target.select()}
        onClick={list.show}
        onKeyDown={list.onKeyDown(pick)}
        onBlur={list.close}
      />
      {list.open && (
        <OptionList id={listId} label={label} options={list.matches} active={list.active}
                    picked={value ? [value] : []} onPick={pick} />
      )}
    </span>
  );
}
